import { Attribution } from '@models/api/Attribution'
import { request } from '../request'

export const attribution = {
  url: {
    getAttributions: '/attribution/getAttributions'
  },

  getAttributions: async function (): Promise<Attribution[]> {
    return (await request.get(this.url.getAttributions)).data
  },

  getAttributionLogo: async function (attributionId: string): Promise<Blob> {
    const result = await request.get(
      `/attribution/getImageAttributions?id_attribution=${attributionId}`,
      {
        responseType: 'arraybuffer'
      }
    )
    return new Blob([result.data], { type: result.headers['content-type'] })
  }
}
